<template>
  <h1 class="category">{{category}}</h1>
</template>

<script>
export default {
  name: 'Category',
  props: {
    category: String
  }
}
</script>

<style scoped>
  .category {
    background: linear-gradient( 45deg, rgb(215,81,0) 0%, rgb(253,135,3) 100%);
    box-shadow: 3.536px 3.536px 3px 0px rgba(0, 0, 0, 0.18);
    clip-path: polygon(0 0, 100% 0, 95% 100%, 0 100%);
    color: #fff;
    font-family: "futura-pt", sans-serif;
    font-size: 60px;
    font-weight: 600;
    left: 0;
    letter-spacing: 3px;
    line-height: 89px;
    margin: 0;
    padding: 0 40px;
    position: absolute;
    height: 88px;
    top: 87px;
    z-index: 1;
  }
</style>